var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.change.valueOld || _vm.STATUS_NAMES.NONE)+" "),_c('TimelineArrow'),_vm._v(" "+_vm._s(_vm.change.valueNew)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }